import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import { iniciarAcessibilidade } from './acessibilidade';
import './acessibilidadePainel/i18n';
import { aplicarNoDocumento, lerEspelho } from './acessibilidadePainel/preferencias';

iniciarAcessibilidade();
// Preferências do painel de Acessibilidade gravadas neste aparelho, antes do
// primeiro desenho (sem piscar o padrão). Sem preferência, nada acontece aqui.
aplicarNoDocumento(lerEspelho());

const root = ReactDOM.createRoot(document.getElementById('root'));

const Root = () => {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

root.render(<Root />);
